// Message template generator for payment reminders

export const generateWhatsAppMessage = (orderNo, customerName, amount, dueDateTime, link = '#') => {
  const firstName = customerName.split(' ')[0];
  const formattedDate = new Date(dueDateTime).toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  
  return `Hi ${firstName}, your order #${orderNo} has a pending advance of ₹${amount.toLocaleString('en-IN')}. Please pay by ${formattedDate}. Link: ${link}`;
};

export const generateSMSMessage = (orderNo, customerName, amount, dueDateTime, link = '#') => {
  return generateWhatsAppMessage(orderNo, customerName, amount, dueDateTime, link);
};

export const generateEmailSubject = (orderNo, amount) => {
  return `Reminder: Advance due for Order #${orderNo} (₹${amount.toLocaleString('en-IN')})`;
};

export const generateEmailBody = (orderNo, customerName, amount, dueDateTime, orderSummary = '', link = '#') => {
  const formattedDate = new Date(dueDateTime).toLocaleString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  
  return `Dear ${customerName},

This is a friendly reminder regarding your order.

Order #: ${orderNo}
Pending Advance: ₹${amount.toLocaleString('en-IN')}
Due By: ${formattedDate}

${orderSummary ? `Order Summary:\n${orderSummary}\n\n` : ''}Please arrange to make the payment at your earliest convenience.

You can view your order details here: ${link}

For any queries, please feel free to contact us.

Thank you!

Best regards`;
};

// Deep link generators
export const generateWhatsAppDeepLink = (phone, message) => {
  // Remove +91 or any country code, keep only 10 digits
  const cleanPhone = phone.replace(/\D/g, '').slice(-10);
  const encodedMessage = encodeURIComponent(message);
  
  // WhatsApp deep link that works on mobile and desktop
  return `https://wa.me/91${cleanPhone}?text=${encodedMessage}`;
};

export const generateSMSDeepLink = (phone, message) => {
  const cleanPhone = phone.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  
  // SMS deep link (works on iOS and Android)
  return `sms:${cleanPhone}?body=${encodedMessage}`;
};

export const generateEmailDeepLink = (email, subject, body) => {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  
  // Mailto link
  return `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
};

export const openWhatsApp = (phone, message) => {
  const link = generateWhatsAppDeepLink(phone, message);
  window.open(link, '_blank');
};

export const openSMS = (phone, message) => {
  const link = generateSMSDeepLink(phone, message);
  window.location.href = link;
};

export const openEmail = (email, subject, body) => {
  const link = generateEmailDeepLink(email, subject, body);
  window.location.href = link;
};
